export const addCmsUrl = (string: string, cmsUrl: string) => {
  return string.replace(/src="((?!http).+?)"/g, `src="${cmsUrl}$1"`)
}
